import './backForward';
import './polyfills';
import { BugsnagClient, bootstrap, initEnvironment, initLocale, APP_CONFIG, getHybridApp, userService, initializeDynatraceLogger } from '@vmos2/core';
import { registerApplication, start } from 'single-spa';
import { constructApplications, constructRoutes, constructLayoutEngine } from 'single-spa-layout';

(async () => {
  const hybridApp = await getHybridApp();

  const routes = constructRoutes(`
    <single-spa-router containerEl="#single-spa-application-root">
      ${hybridApp ?
      ` <redirect from="/index.html" to="/welcome/introduction"></redirect>
          <redirect from="/delivery/welcome" to="/welcome"></redirect>
          <redirect from="/o/welcome" to="/welcome"></redirect>
        ` : ''}
      ${(hybridApp && hybridApp.isReactNativeApp) ?
      `<redirect from="/" to="/welcome/introduction"></redirect>` :
      `<redirect from="/" to="/store/store-selection"></redirect>`}
      <redirect from="/delivery/store/store-selection" to="/store/store-selection"></redirect>
      <redirect from="/o/store/store-selection" to="/store/store-selection"></redirect>
      <route default>
        <application name="@vmos2/kiosk"></application>
      </route>
      <route path="store/store-selection">
        <application name="@vmos2/storeSelection"></application>
      </route>
      <route path="welcome">
        <application name="@vmos2/welcome"></application>
      </route>
      <route path="claim">
        <application name="${ hybridApp ? '@vmos2/welcome' : '@vmos2/storeSelection' }"></application>
      </route>
    </single-spa-router>
  `);

  const applications = constructApplications({
    routes,
    loadApp({ name }) {
      switch (name) {
        case '@vmos2/kiosk':
          return import('@vmos2/kiosk');
        case '@vmos2/storeSelection':
          return import('@vmos2/storeSelection');
        case '@vmos2/welcome':
          return import('@vmos2/welcome');
        default:
          throw new Error('unknown app');
      }
    },
  });

  const layoutEngine = constructLayoutEngine({ routes, applications });

  await initEnvironment();

  const bootstrapPromise = bootstrap();

  bootstrapPromise.then(bootstrap => {
    try {
      userService.fetchUser().then((user) => initLocale(bootstrap, user));

      initializeDynatraceLogger(APP_CONFIG.DYNATRACE_SERVERLESS, hybridApp, bootstrap);

      /**
       * we send a message to react native layer
       * to inform that bootstrap was loaded successfully
       * so that some things can be executed post bootstrap.
       * for eg. branch.Io subscription.
       */
      if (hybridApp && window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify('bootstrap_loaded'));
      };
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  }).catch(console.error);
  BugsnagClient.init(APP_CONFIG.BUGSNAG_API_KEY, APP_CONFIG.APP_STAGE);

  applications.forEach(app => {
    registerApplication({
      ...app,
      customProps: { bootstrapPromise },
    });
  });

  layoutEngine.activate();
  start();
})();
